import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

export default function Login() {
  const { login, cargando } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const r = await login(form.email, form.password);
    if (r.ok) navigate('/');
    else toast.error(r.error);
  };

  return (
    <div style={{ minHeight:'100vh', background:'#1a1a2e', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:24 }}>
      {/* Logo */}
      <div style={{ marginBottom:32, textAlign:'center' }}>
        <div style={{ fontSize:48, marginBottom:8 }}>🧁</div>
        <div style={{ color:'white', fontSize:28, fontWeight:800, letterSpacing:'-0.5px' }}>Gelatus</div>
        <div style={{ color:'rgba(255,255,255,0.5)', fontSize:13, marginTop:4 }}>Portal del equipo</div>
      </div>

      {/* Card */}
      <div style={{ background:'white', borderRadius:20, padding:28, width:'100%', maxWidth:360, boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
        <h2 style={{ margin:'0 0 20px', fontSize:18, fontWeight:700, color:'#111827' }}>Iniciar sesión</h2>
        <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:14 }}>
          <div>
            <label style={{ fontSize:12, fontWeight:700, color:'#6B7280', textTransform:'uppercase', display:'block', marginBottom:4 }}>Correo o usuario</label>
            <input
              type="text" value={form.email}
              onChange={e => setForm(f=>({...f, email:e.target.value}))}
              placeholder="correo@gelatus.co"
              style={{ width:'100%', padding:'12px 14px', border:'2px solid #E5E7EB', borderRadius:10, fontSize:15, outline:'none', boxSizing:'border-box' }}
              required autoFocus autoComplete="username"
            />
          </div>
          <div>
            <label style={{ fontSize:12, fontWeight:700, color:'#6B7280', textTransform:'uppercase', display:'block', marginBottom:4 }}>Contraseña</label>
            <input
              type="password" value={form.password}
              onChange={e => setForm(f=>({...f, password:e.target.value}))}
              placeholder="••••••••"
              style={{ width:'100%', padding:'12px 14px', border:'2px solid #E5E7EB', borderRadius:10, fontSize:15, outline:'none', boxSizing:'border-box' }}
              required autoComplete="current-password"
            />
          </div>
          <button type="submit" disabled={cargando}
            style={{ padding:'13px', background:'#1a1a2e', color:'white', border:'none', borderRadius:10, fontSize:15, fontWeight:700, cursor:'pointer', marginTop:4 }}>
            {cargando ? '⏳ Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>

      <div style={{ color:'rgba(255,255,255,0.3)', fontSize:12, marginTop:24 }}>
        Gelatus Colombia · Portal interno
      </div>
    </div>
  );
}
